import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import Admin from "../components/Admin";

class AdminRoute extends Component {
    render() {
        const { user, loggedIn } = this.props;
        if (!loggedIn || !user || !user.isAdmin) return <Redirect to="/" />;
        return <Admin />;
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loggedIn: state.user.bearerToken ? true : false,
        user: state.user.data,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {};
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminRoute);
